import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { ModalBody, Modal } from "reactstrap";
import fixNumbers from "../../base/utils/fix_Numbers";

export default function AcceptModal({
  acceptModal,
  acceptModalChange,
  pending,
  title,
  text,
  accept,
  haveDiscount,
}) {
  const [discount, setDiscount] = useState("");

  return (
    <div>
      <Modal
        dir="rtl"
        zIndex="99999"
        className="m-0"
        contentClassName="border-0 position-fixed fixed-bottom w-auto max-h-75 bg-none"
        isOpen={acceptModal}
        toggle={() => acceptModalChange(false)}
      >
        <div className="row mx-0 px-0 justify-content-center">
          <div className="col-12 col-md-6 px-0">
            <ModalBody className="row mx-0 p-4 rounded-top-28 bg-light">
              <div className="col-12 px-0 fw-bold text-center mb-4">
                {title || "تایید عملیات"}
              </div>
              <div className="col-12 px-0 fw-bold small text-center mb-4">
                {text}
              </div>
              {haveDiscount && (
                <div className="col-12 px-0 fw-bold small text-center mb-4">
                  <input
                    id="discount-input"
                    className="form-control bg-light-gray rounded7 border-0 fw-bold text-center px-2 d-inline-block shadow-sm w-50"
                    type="text"
                    value={discount}
                    autocomplete="off"
                    onChange={(e) =>
                      /^[a-zA-Z0-9]*$/.test(fixNumbers(e.target.value)) &&
                      setDiscount(fixNumbers(e.target.value))
                    }
                    placeholder="کد تخفیف (اختیاری)"
                    maxLength="20"
                  />
                </div>
              )}
              <div className="col-6 px-1">
                <button
                  className="btn bg-main rounded7 text-white w-100 py-2-3"
                  onClick={() => accept()}
                  disabled={pending}
                >
                  {pending ? (
                    <Spinner
                      className="align-middle"
                      animation="border"
                      size="sm"
                    />
                  ) : (
                    "تایید"
                  )}
                </button>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn w-100 py-2-3"
                  onClick={() => acceptModalChange(false)}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </div>
        </div>
      </Modal>
    </div>
  );
}
